import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-manual',
  templateUrl: './manual.component.html',
  styleUrls: ['./manual.component.css'],
})
export class ManualComponent implements OnInit {
  userUid: string;
  rol: any;
  datosusuario: any;
  manuales = [
    {
      nombre: 'Manual de estudiante',
      url: 'https://firebasestorage.googleapis.com/v0/b/thecampus-colegios.firebasestorage.app/o/MANUALES%2FManual_Alumno_TheCampus(ESP).pdf?alt=media&token=80df8d89-ef1d-4856-962d-9cad2be3a238',
    },
    {
      nombre: 'Manual de profesor',
      url: 'https://firebasestorage.googleapis.com/v0/b/thecampus-colegios.firebasestorage.app/o/MANUALES%2FManual_Alumno_TheCampus(ESP).pdf?alt=media&token=80df8d89-ef1d-4856-962d-9cad2be3a238',
    },
    {
      nombre: 'Student Manual',
      url: 'https://firebasestorage.googleapis.com/v0/b/thecampus-colegios.firebasestorage.app/o/MANUALES%2FManual_Alumno_TheCampus(ESP).pdf?alt=media&token=80df8d89-ef1d-4856-962d-9cad2be3a238',
    },
    {
      nombre: "Teacher's manual",
      url: 'https://firebasestorage.googleapis.com/v0/b/thecampus-colegios.firebasestorage.app/o/MANUALES%2FManual_Alumno_TheCampus(ESP).pdf?alt=media&token=80df8d89-ef1d-4856-962d-9cad2be3a238',
    },
  ];
  manual: any = {
    nombre: 'Manual de estudiante',
    url: 'https://firebasestorage.googleapis.com/v0/b/thecampus-colegios.firebasestorage.app/o/MANUALES%2FManual_Alumno_TheCampus(ESP).pdf?alt=media&token=80df8d89-ef1d-4856-962d-9cad2be3a238',
  };

  videosPildoraEs = [
    // {
    //   titulo: 'Descubre cómo funciona The Campus',
    //   src: 'assets/video/pildoras/Descubre cómo funciona la interfaz The Campus.mp4',
    // },
    {
      titulo: 'Cambiar idioma',
      src: 'assets/video/pildoras/Cambiar idioma_edit.mp4',
    },
    {
      titulo: 'Cambiar modo de visualización',
      src: 'assets/video/pildoras/Cambiar modo de visualización_edit.mp4',
    },
    {
      titulo: 'Cómo crear un evento',
      src: 'assets/video/pildoras/Cómo crear un evento.mp4',
    },
    {
      titulo: 'Editar evento creado por mi',
      src: 'assets/video/pildoras/Editar evento creado por mi_edit.mp4',
    },
    {
      titulo: 'Enviar un mensaje',
      src: 'assets/video/pildoras/Enviar un mensaje_edit.mp4',
    },
    {
      titulo: 'Ver archivos',
      src: 'assets/video/pildoras/ver archivos_edit.mp4',
    },
  ];

  videosPildoraEn = [
    // {
    //   titulo: 'Discover The Campus',
    //   src: 'assets/video/pildoras/Discover The Campus.mp4',
    // },
    {
      titulo: 'Change Languaje',
      src: 'assets/video/pildoras/How to change the language_temp.mp4',
    },
    {
      titulo: 'How to enter the class',
      src: 'assets/video/pildoras/How to enter the class.mp4',
    },
    {
      titulo: 'how to change the layouts',
      src: 'assets/video/pildoras/how to change the layouts_temp.mp4',
    },
    {
      titulo: 'How to create an event',
      src: 'assets/video/pildoras/How to create an event_temp.mp4',
    },
    {
      titulo: 'How to edit an event',
      src: 'assets/video/pildoras/How to edit an event.mp4',
    },
    {
      titulo: 'How to send a message',
      src: 'assets/video/pildoras/How to send a message.mp4',
    },
    {
      titulo: 'How to see a file',
      src: 'assets/video/pildoras/How to see a file_temp.mp4',
    },
  ];
  videosPildoraIdioma = [];
  videosDesplegados: boolean = true;
  idioma: string;

  urlProblemas = '/assets/media/Hoja de ayuda acceso Colegia.pdf';
  colegio: any;

  constructor(
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    const Userdata: any = this.userService.getUserinfodata();
    if (Userdata === undefined) {
      this.authenticationService.isAuth().subscribe((auth) => {
        if (auth) {
          this.userUid = auth.uid; /* id del usuario */
          this.authenticationService
            .isUserAdmin(this.userUid)
            .subscribe((userdata) => {
              if (userdata[0]) {
                this.datosusuario = userdata[0];
                this.rol = this.datosusuario.rol;
                this.colegio = this.datosusuario.colegios[0];
                if (localStorage.getItem('idioma')) {
                  this.idioma = localStorage.getItem('idioma');
                  console.log(this.idioma);
                } else {
                  this.idioma = 'es';
                }
                this.cogerManual();
                this.cogerVideos();
              }
            });
        }
      });
    } else {
      this.userUid = Userdata.payload.doc.data().uid; /* id del usuario */
      this.datosusuario = Userdata.payload.doc.data();
      this.rol = Userdata.payload.doc.data().rol;
      this.colegio = this.datosusuario.colegios[0];
      if (localStorage.getItem('idioma')) {
        this.idioma = localStorage.getItem('idioma');
        console.log(this.idioma);
      } else {
        this.idioma = 'en';
      }

      this.cogerManual();
      this.cogerVideos();
    }
  }
  cogerManual() {
    switch (this.idioma) {
      case 'es':
        this.rol == 'estudiante'
          ? (this.manual = this.manuales[0])
          : (this.manual = this.manuales[1]);
        break;
      case 'en':
        this.rol == 'estudiante'
          ? (this.manual = this.manuales[2])
          : (this.manual = this.manuales[3]);
        break;
      default:
        this.rol == 'estudiante'
          ? (this.manual = this.manuales[2])
          : (this.manual = this.manuales[3]);
        break;
    }

    if (this.idioma != 'es') {
      this.urlProblemas = '/assets/media/Guia-Soluciones conferencia.pdf';
    }
  }
  cogerVideos() {
    switch (this.idioma) {
      case 'es':
        this.videosPildoraIdioma = this.videosPildoraEs;
        break;
      case 'en':
        this.videosPildoraIdioma = this.videosPildoraEn;
        break;
      default:
        this.videosPildoraIdioma = this.videosPildoraEn;
        break;
    }
  }

  desplegarVideos() {
    this.videosDesplegados = !this.videosDesplegados;
  }
}
